import React from "react";
import "./HomeClients.css";
import ClientSlider from "../ClientSlider/ClientSlider";

function HomeClients({ clients }) {
  return (
    <>
      <div className="homeClients-container">
        <div className="client-title-section">
          <p>REVOLUTIONIZING HEALTHCARE WITH</p>
          <p>CUTTING-EDGE MEDICAL SOLUTIONS THAT EMPOWER PROFESSIONALS</p>
          <p className="third-title">AND ENHANCE PATIENT LIVES</p>
        </div>

        <div className="slider-container-withtitle">
          <div className="title-slider">
            <p>OUR</p>
            <p>TRUSTED</p>
            <p>SOURCES</p>
          </div>
          <div className="mobile-title-slider">
            <p>OUR TRUSTED</p>
            <p>SOURCES</p>
          </div>
        </div>
      </div>
      <ClientSlider clients={clients} />
    </>
  );
}

export default HomeClients;
